export default "/assets/images/opened-unit.png?c90722a266efb7fc936ce3d2946057ce";